var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "기본정보" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-plant", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        type: "edit",
                        name: "plantCd",
                      },
                      model: {
                        value: _vm.fireFightingPermit.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingPermit, "plantCd", $$v)
                        },
                        expression: "fireFightingPermit.plantCd",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        name: "permitDt",
                        label: "허가일시",
                      },
                      model: {
                        value: _vm.fireFightingPermit.permitDt,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingPermit, "permitDt", $$v)
                        },
                        expression: "fireFightingPermit.permitDt",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-field", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        data: _vm.fireFightingPermit,
                        deptValue: "workManagerDeptCd",
                        type: "dept_user",
                        name: "workManagerId",
                        label: "작업책임자",
                      },
                      model: {
                        value: _vm.fireFightingPermit.workManagerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingPermit, "workManagerId", $$v)
                        },
                        expression: "fireFightingPermit.workManagerId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-field", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled || _vm.disabledWorkPermit,
                        data: _vm.fireFightingPermit,
                        deptValue: "fireSafetyManagerDeptCd",
                        type: "dept_user",
                        name: "fireSafetyManagerId",
                        label: "소방안전관리자",
                      },
                      model: {
                        value: _vm.fireFightingPermit.fireSafetyManagerId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.fireFightingPermit,
                            "fireSafetyManagerId",
                            $$v
                          )
                        },
                        expression: "fireFightingPermit.fireSafetyManagerId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-field", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled || _vm.disabledWorkPermit,
                        data: _vm.fireFightingPermit,
                        deptValue: "fireWatchmanDeptCd",
                        type: "dept_user",
                        name: "fireWatchmanId",
                        label: "화재감시자",
                      },
                      model: {
                        value: _vm.fireFightingPermit.fireWatchmanId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.fireFightingPermit,
                            "fireWatchmanId",
                            $$v
                          )
                        },
                        expression: "fireFightingPermit.fireWatchmanId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        label: "작업장소",
                        name: "workLocation",
                      },
                      model: {
                        value: _vm.fireFightingPermit.workLocation,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingPermit, "workLocation", $$v)
                        },
                        expression: "fireFightingPermit.workLocation",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        label: "작업개요",
                        name: "workSummary",
                      },
                      model: {
                        value: _vm.fireFightingPermit.workSummary,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingPermit, "workSummary", $$v)
                        },
                        expression: "fireFightingPermit.workSummary",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: true,
                        label: "허가번호",
                        name: "permitNo",
                      },
                      model: {
                        value: _vm.fireFightingPermit.permitNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingPermit, "permitNo", $$v)
                        },
                        expression: "fireFightingPermit.permitNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
                  [
                    _c("c-checkbox", {
                      attrs: {
                        editable: _vm.editable,
                        disabled: _vm.disabled || _vm.disabledWorkPermit,
                        isArray: false,
                        codeGroupCd: "SOP_FIRE_WORK_CLASSIFICATION",
                        valueText: "codeName",
                        valueKey: "code",
                        label: "작업구분",
                        name: "fireWorkClassification",
                      },
                      on: { datachange: _vm.workClassChange },
                      model: {
                        value: _vm.fireFightingPermit.fireWorkClassification,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.fireFightingPermit,
                            "fireWorkClassification",
                            $$v
                          )
                        },
                        expression: "fireFightingPermit.fireWorkClassification",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-2 col-lg-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.editable,
                        disabled:
                          _vm.disabled ||
                          _vm.disabledWorkPermit ||
                          _vm.disableEtc,
                        label: "작업구분(기타)",
                        name: "fireWorkClassificationEtc",
                      },
                      model: {
                        value: _vm.fireFightingPermit.fireWorkClassificationEtc,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.fireFightingPermit,
                            "fireWorkClassificationEtc",
                            $$v
                          )
                        },
                        expression:
                          "fireFightingPermit.fireWorkClassificationEtc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        disabled: _vm.disabled,
                        editable: _vm.editable,
                        rows: 2,
                        label: "비고",
                        name: "remarks",
                      },
                      model: {
                        value: _vm.fireFightingPermit.remarks,
                        callback: function ($$v) {
                          _vm.$set(_vm.fireFightingPermit, "remarks", $$v)
                        },
                        expression: "fireFightingPermit.remarks",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c("c-table", {
                  attrs: {
                    title: "화기 체크리스트",
                    isTitle: "",
                    gridHeightAuto: "",
                    columns: _vm.gridChecklist.columns,
                    data: _vm.fireChecklistResults,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    editable: _vm.editable && !_vm.disabled,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          props.row["textFlag"] === "N"
                            ? [
                                _c("q-checkbox", {
                                  staticClass: "tableCheckBox",
                                  attrs: {
                                    dense: "",
                                    color: "orange-custom",
                                    disable: !(_vm.editable && !_vm.disabled),
                                    "true-value": "O",
                                    "false-value": "X",
                                  },
                                  on: {
                                    input: (val) => _vm.datachange(props, col),
                                  },
                                  model: {
                                    value: props.row[col.name],
                                    callback: function ($$v) {
                                      _vm.$set(props.row, col.name, $$v)
                                    },
                                    expression: "props.row[col.name]",
                                  },
                                }),
                              ]
                            : [
                                _c("c-text-column", {
                                  attrs: {
                                    editable: _vm.editable,
                                    disable: _vm.disabled,
                                    col: col,
                                    props: props,
                                  },
                                  on: {
                                    datachange: function ($event) {
                                      return _vm.datachange(props, col)
                                    },
                                  },
                                }),
                              ],
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6" },
              [
                _c(
                  "div",
                  { staticStyle: { height: "0" } },
                  [
                    !_vm.confiFlag
                      ? _c(
                          "q-banner",
                          {
                            staticClass:
                              "text-white bg-red step-table-info-banner",
                            attrs: { "inline-actions": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "avatar",
                                  fn: function () {
                                    return [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "info_outline",
                                          color: "white",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4205562712
                            ),
                          },
                          [_vm._v(" 밀폐 보충작업을 하지 않는 허가서입니다. ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("c-table", {
                  attrs: {
                    title: "밀폐 체크리스트",
                    isTitle: "",
                    gridHeightAuto: "",
                    columns: _vm.gridChecklist.columns,
                    data: _vm.confiChecklistResults,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    editable: _vm.editable && !_vm.disabled,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          props.row["textFlag"] === "N"
                            ? [
                                _c("q-checkbox", {
                                  staticClass: "tableCheckBox",
                                  attrs: {
                                    dense: "",
                                    color: "orange-custom",
                                    disable: !(_vm.editable && !_vm.disabled),
                                    "true-value": "O",
                                    "false-value": "X",
                                  },
                                  on: {
                                    input: (val) => _vm.datachange(props, col),
                                  },
                                  model: {
                                    value: props.row[col.name],
                                    callback: function ($$v) {
                                      _vm.$set(props.row, col.name, $$v)
                                    },
                                    expression: "props.row[col.name]",
                                  },
                                }),
                              ]
                            : [
                                _c("c-text-column", {
                                  attrs: {
                                    editable: _vm.editable,
                                    disable: _vm.disabled,
                                    col: col,
                                    props: props,
                                  },
                                  on: {
                                    datachange: function ($event) {
                                      return _vm.datachange(props, col)
                                    },
                                  },
                                }),
                              ],
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
              [
                _c("c-table", {
                  attrs: {
                    title: "화기 안전조치 요구사항",
                    isTitle: "",
                    gridHeightAuto: "",
                    columns: _vm.gridFire.columns,
                    data: _vm.fireFightingPermit.fireCheckResults,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    editable:
                      _vm.editable && !_vm.disabled && !_vm.disabledWorkPermit,
                    contentsField: _vm.contentsField,
                  },
                  on: { "table-data-change": _vm.tableDataChange },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
              [
                _c(
                  "div",
                  { staticStyle: { height: "0" } },
                  [
                    !_vm.confiFlag
                      ? _c(
                          "q-banner",
                          {
                            staticClass:
                              "text-white bg-red step-table-info-banner",
                            attrs: { "inline-actions": "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "avatar",
                                  fn: function () {
                                    return [
                                      _c("q-icon", {
                                        attrs: {
                                          name: "info_outline",
                                          color: "white",
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4205562712
                            ),
                          },
                          [_vm._v(" 밀폐 보충작업을 하지 않는 허가서입니다. ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("c-table", {
                  attrs: {
                    title: "밀폐 안전조치 요구사항",
                    isTitle: "",
                    gridHeightAuto: "",
                    columns: _vm.gridConfinedSpace.columns,
                    data: _vm.fireFightingPermit.confinedSpaceCheckResults,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    editable:
                      _vm.editable &&
                      !_vm.disabled &&
                      !_vm.disabledWorkPermit &&
                      _vm.confiFlag,
                    contentsField: _vm.contentsField,
                  },
                  on: { "table-data-change": _vm.tableDataChange },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
              [
                _c("c-table", {
                  attrs: {
                    title: "작업종료 후 안전조치 (작업종료 후 작성 → 반납)",
                    isTitle: "",
                    gridHeightAuto: "",
                    columns: _vm.gridPermitConfirm.columns,
                    data: _vm.gridPermitConfirm.data,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    editable: false,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable && _vm.isWorking && !_vm.disabled,
                      expression: "editable && isWorking && !disabled",
                    },
                  ],
                  attrs: {
                    flat: "",
                    url: _vm.completeUrl,
                    isSubmit: _vm.isComplete,
                    param: _vm.fireFightingPermit,
                    mappingType: "PUT",
                    label: "완료",
                    icon: "check",
                  },
                  on: {
                    beforeAction: _vm.completeInfo,
                    btnCallback: _vm.completeCallback,
                  },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable && !_vm.disabled,
                      expression: "editable && !disabled",
                    },
                  ],
                  attrs: {
                    flat: "",
                    url: _vm.saveUrl,
                    isSubmit: _vm.isSave,
                    param: _vm.fireFightingPermit,
                    mappingType: "PUT",
                    label: "저장",
                    icon: "save",
                  },
                  on: {
                    beforeAction: _vm.saveInfo,
                    btnCallback: _vm.saveCallback,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }